module.exports = __webpack_public_path__ + "static/media/nyc.0ce03c0b.png";